// import React from 'react';
// import Bgimage from "../../images/EXPLORE DIVISIONS/steel-logo-2.jpg"; 

// function OurExpertise() {
//   return (
//     <div>
//       <div className="mx-auto text-center md:py-2">
//         <section
//           className="w-full bg-cover bg-center bg-no-repeat text-white rounded-lg py-2 md:py-16"
//           style={{ backgroundImage: `url(${Bgimage})` }} 
//         >
//           <div className="gap-6 items-center">
//             <div className="p-2 md:p-6 rounded-lg"> 
//               <h2 className="text-3xl md:text-4xl font-bold mb-2">ROOF COATINGS DIVISION</h2>
//               <p className="sm:p-4 md:p-7 rounded-lg text-lg md:text-2xl md:px-28">
//               Our Roof Coatings specializes in protective coatings for commercial, industrial, and residential roofs. These coatings offer waterproofing, UV resistance, and energy efficiency, extending the lifespan of metal, concrete, and asphalt roofs.
//               </p>
//             </div>
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// }

// export default OurExpertise;

import React from "react";
import Indusone from "../../images/aktcorp/search-product-image.jpg";

function OurExpertise() {
  return (
    <div className="w-full">
      {/* Top Section - Image & Text */}
      <div className="mx-auto md:mt-3">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
          {/* Left Side - Text Content */}
          <div className="lg:col-span-5 bg-white text-[#0c2340] p-6 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
            <h2 className="text-2xl md:text-4xl font-bold mb-2 md:mb-4 text-center">
            ROOF COATINGS
            </h2>
            <p className="text-sm md:text-lg mb-6 text-justify md:mt-2">
            Our Roof Coatings specializes in providing high-quality protective coatings designed for commercial, industrial, and residential roofs. These advanced coatings offer exceptional waterproofing, ensuring roofs stay dry and protected from the elements, while also providing UV resistance to prevent damage from harsh sunlight. Our coatings also contribute to energy efficiency, helping reduce cooling costs by reflecting heat and keeping buildings cooler. By extending the lifespan of metal, concrete, and asphalt roofs, our solutions offer long-term value and protection for any roofing system.
            </p>
          </div>

          {/* Right Side - Image */}
          <div className="lg:col-span-7 flex">
            <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusone}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurExpertise;
